import { render, staticRenderFns } from "./CloFooterListHeading.vue?vue&type=template&id=0e143006&"
import script from "./CloFooterListHeading.vue?vue&type=script&lang=js&"
export * from "./CloFooterListHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports